import { css } from "styled-components";

export const ease = css`
  transition: all 0.1s ease;
`;
